import { Inject, Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LoadingScreenService } from '../services/loading-screen.service';
import { finalize } from 'rxjs/operators';

@Injectable()
export class LoadingScreenInterceptor implements HttpInterceptor {
  activeRequests = 0;

  constructor(
    private loadingScreenService: LoadingScreenService,
    @Inject('loadingInterceptorSkipHeader') private loadingInterceptorSkipHeader: any
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // request header that dictates loading animation display
    if (request.headers.has(this.loadingInterceptorSkipHeader)) {
      request.headers.delete(this.loadingInterceptorSkipHeader);

      // do not display the loading animation
      return next.handle(request);
    } else {
      if (this.activeRequests === 0) {
        this.loadingScreenService.startLoading();
      }
      this.activeRequests++;

      return next.handle(request).pipe(
        finalize(() => {
          this.activeRequests--;
          if (this.activeRequests === 0) {
            this.loadingScreenService.stopLoading();
          }
        })
      );
    }
  }
}
